import { render } from "./Tickets.vue?vue&type=template&id=3b46d1fa&scoped=true"
import script from "./Tickets.vue?vue&type=script&lang=js"
export * from "./Tickets.vue?vue&type=script&lang=js"

import "./Tickets.vue?vue&type=style&index=0&id=3b46d1fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b46d1fa"],['__file',"resources/js/components/lockstep/Tickets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b46d1fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b46d1fa', __exports__)) {
    api.reload('3b46d1fa', __exports__)
  }
  
  module.hot.accept("./Tickets.vue?vue&type=template&id=3b46d1fa&scoped=true", () => {
    api.rerender('3b46d1fa', render)
  })

}


export default __exports__